import { render, staticRenderFns } from "./InstructionsList.vue?vue&type=template&id=458c55e6"
import script from "./InstructionsList.js?vue&type=script&lang=js&external"
export * from "./InstructionsList.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports